import {Announcement} from "./announcements.model";

export class AnnouncementSummary{
  constructor(
    public wpAnnouncement?: Announcement[],
  ){
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/announcementSummary.model.ts